import {
  AttendanceRequest,
  CreateAttendanceRequest,
  CreateAttendanceResponse,
  ExportAttendanceByDayRequest,
  ExportAttendanceByDayResponse,
  GetAttendanceErrorByRangeDayRequest,
  GetAttendanceErrorByRangeDayResponse,
  GetAttendanceResponse,
  UpdateAttendanceRequest,
  UpdateAttendanceResponse,
} from '@/types/apis/attendance'

import axios from './axios'

const API_ENDPOINT = '/attendance'

export const getAttendanceByDay = (request: AttendanceRequest): Promise<GetAttendanceResponse> => {
  return axios.get(`${API_ENDPOINT}/attendance-by-date`, { params: request })
}

export const exportAttendanceByDay = (
  request: ExportAttendanceByDayRequest
): Promise<ExportAttendanceByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-attendance-by-date`, { params: request })
}

export const updateAttendanceByDay = (request: UpdateAttendanceRequest): Promise<UpdateAttendanceResponse> => {
  return axios.put(`${API_ENDPOINT}/${request.id}`, request)
}

export const createAttendanceByDay = (request: CreateAttendanceRequest): Promise<CreateAttendanceResponse> => {
  return axios.post(`${API_ENDPOINT}/admin`, request)
}

export const deleteAttendanceByDay = (id: number): Promise<void> => {
  return axios.delete(`${API_ENDPOINT}/${id}`)
}

export const getAttendanceErrorByRangeDay = (
  request: GetAttendanceErrorByRangeDayRequest
): Promise<GetAttendanceErrorByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/attendance-errors-by-range-date`, { params: request })
}
